export default {
  data() {
    from: "";
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from.path;
    });
  },

  methods: {
    login() {
      // 发送请求,用post方式
      let url = "/user/login";
      // 请求参数
      let data = {
        phone: this.phone,
        smsCode: this.smsCode
      };
      this.$axios
        .post(url, data)
        .then(res => {
          // 修改登陆状态
          this.$store.commit("updateLogin", true);
          // 把token存入store
          this.$store.commit("updateToken", res.result.token);
          // 把用户名存入store
          this.$store.commit("updatePhone", res.result.phone);
          this.$router.go(-1);

          // if (this.from === "/register") {
          //   this.$router.push("/my/center");
          // } else {
          //   this.$router.go(-1);
          // }
        })
        .catch(err => {
          this.$fail(err);
        });
    }
  }
};
